import { useAuth } from '@clerk/clerk-react'
import { Link } from 'react-router-dom'

import { Logo } from '@/components/brand/Logo'

const COLUMNS: {
  heading: string
  links: { label: string; href: string }[]
}[] = [
  {
    heading: 'Platform',
    links: [
      { label: 'Browse', href: '/discover' },
      { label: 'Post', href: '/drop' },
      { label: 'Stash', href: '/stash' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Support', href: '/support' },
      { label: 'Twitter', href: '#' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms', href: '#' },
      { label: 'Privacy', href: '#' },
    ],
  },
]

export function SiteFooter() {
  const { isLoaded, isSignedIn } = useAuth()
  const homeTo = isLoaded && isSignedIn ? '/discover' : '/'
  const year = new Date().getFullYear()

  return (
    <footer className="border-glass-border bg-surface-dim mt-auto border-t pt-12 pb-24 md:pb-12">
      <div className="max-w-site px-margin-mobile md:px-margin-desktop mx-auto grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 space-y-4 md:col-span-1">
          <Link to={homeTo} aria-label="dizcant home">
            <Logo />
          </Link>
          <p className="font-body text-label-sm text-fg-muted">
            Referral and discount links that still work.
          </p>
          <p className="font-body text-body-sm text-fg-muted">
            © {year} dizcant.
          </p>
        </div>

        <nav
          aria-label="Footer"
          className="col-span-2 grid grid-cols-3 gap-8 md:col-span-3"
        >
          {COLUMNS.map((column) => (
            <div key={column.heading} className="flex flex-col gap-3">
              <h2 className="font-body text-label-caps text-fg uppercase">
                {column.heading}
              </h2>
              {column.links.map((link) =>
                link.href.startsWith('/') ? (
                  <Link
                    key={link.label}
                    to={link.href}
                    className="font-body text-body-sm text-fg-muted hover:text-primary rounded-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.label}
                    href={link.href}
                    className="font-body text-body-sm text-fg-muted hover:text-primary rounded-sm transition-colors"
                  >
                    {link.label}
                  </a>
                ),
              )}
            </div>
          ))}
        </nav>
      </div>
    </footer>
  )
}
